import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import { useAuth } from "../../contexts/AuthContext";
import SETTINGS from "../../globals";
import PagedData from "../../model/PagedData";
import APIEndPoints from "../../utils/APIEndPoints";
import AppSections from "../../utils/AppSections";
import StaticPage from "../../model/StaticPage";
import AppIcons from "../../utils/AppIcons";
import AppSubSections from "../../utils/AppSubSections";
import UserRoles from "../../model/enums/UserRole";
import EmbeddingToolInfo from "../../utils/EmbeddingToolInfo";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import StaticPagesListElement from "./StaticPagesListElement";

function StaticPagesList() {
  // reference to the AuthManager
  const authManager = useAuth();
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // activities information to be displayed
  const [data, setData] = useState<StaticPage[]>([]);
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {
    // check if the user has administrator rights
    if (authManager.isAdmin()) {
      apiClient
        ?.get<PagedData<StaticPage[]>>({
          url: APIEndPoints.STATIC_PAGES.ALL,
          requiresToken: true,
        })
        .then((data: PagedData<StaticPage[]>) => {
          setData(data.items);
        })
        .catch(() => {
          navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [apiClient, navigate]);

  // check EDIT rights
  const canEdit =
    !EmbeddingToolInfo.isChemiTool() &&
    authManager.getUserRole() === UserRoles.ADMIN;

  return (
    <div>
      <div className="list-page-header">
        <div className="list-page-title">
          <h1>
            <span>{AppIcons.EDIT}</span>
            Manage Static Content
          </h1>
        </div>
        <div>
          <Button
            label="Create a new Static Page"
            purpose={ButtonAction.CREATE}
            onClick={() =>
              navigate(
                SETTINGS.get_path({
                  section: AppSections.STATIC_PAGES,
                  subsection: AppSubSections.CREATE,
                }),
              )
            }
          />
        </div>
      </div>
      {data?.length === 0 && (
        <div className="list-no-records">No records found.</div>
      )}
      {data?.length > 0 &&
        data.map((item) => {
          return (
            <StaticPagesListElement
              canEdit={canEdit}
              data={item}
              key={item.id}
            />
          );
        })}
    </div>
  );
}

export default StaticPagesList;
